import React from 'react';
import Vue from './taskListModelView';

// La vue porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function TaskListModel() {
  return <Vue />;
}

export default TaskListModel;
